export default __webpack_public_path__ + "static/media/Orchha_Fort_complex_-Orchha_-Madhya_Pradesh_-IMG_4932.23653cdd.jpg";